import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

//Include Both Helper File with needed methods
import {
  getSalesPartnerList as getSalesPartnerListApi,
  getSalesClientList as getSalesClientListApi,
  getSalesNetworkList as getSalesNetworkListApi,
  getSalesMoneyTransferList as getSalesMoneyTransferListApi,
  getSalesEquityReport as getSalesEquityReportApi,
} from "../../helpers/ServiceHelpers/backend_helper";

// Get Sales Partner List
export const getSalesPartnerList = createAsyncThunk(
  "salesReports/getSalesPartnerList",
  async (params: any) => {
    const { id, data } = params;
    try {
      const response = getSalesPartnerListApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get Sales Retail List
export const getSalesClientList = createAsyncThunk(
  "salesReports/getSalesClientList",
  async (params: any) => {
    const { id, data } = params;
    try {
      const response = getSalesClientListApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get Sales Retail List
export const getSalesNetworkList = createAsyncThunk(
  "salesReports/getSalesNetworkList",
  async (params: any) => {
    const { id, data } = params;
    try {
      const response = getSalesNetworkListApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get Sales Money Transfer Report
export const getSalesMoneyTransferList = createAsyncThunk(
  "salesReports/getSalesMoneyTransferList",
  async (params: any) => {
    const { id, data } = params;
    try {
      const response = getSalesMoneyTransferListApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get Sales Equity Report
export const getSalesEquityReport = createAsyncThunk(
  "reports/getSalesEquityReport",
  async (params: any) => {
    const { id, data } = params;
    try {
      const response = getSalesEquityReportApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);
